import { render, staticRenderFns } from "./orders-properties-list.vue?vue&type=template&id=7cc9f9b0&scoped=true"
import script from "./orders-properties-list.vue?vue&type=script&lang=js"
export * from "./orders-properties-list.vue?vue&type=script&lang=js"
import style0 from "./orders-properties-list.vue?vue&type=style&index=0&id=7cc9f9b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc9f9b0",
  null
  
)

export default component.exports